export default __webpack_public_path__ + "static/media/backgroundSFX.4cb5ca73.mp3";